import { FC, ReactElement } from 'react';
import CustomModal from '../../components-library/CustomModal';
import useInitialData from '../../hooks/global/useInitialData';
import CustomButton from '../../components-library/buttons/CustomButton';
import usePlayStore from '../../hooks/mobile-app/usePlayStore';
import CloseCircleIcon from '../../assets/icons/CloseCircleIcon';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
}

const DownloadMobileAppModal: FC<Props> = ({ onClose }): ReactElement => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:Marketing:DownloadMobileAppModal' });
  const { data } = useInitialData();
  const { franchise } = data;
  const { mobile_app } = franchise;
  const { openStore } = usePlayStore();

  return mobile_app ? (
    <CustomModal open onClose={onClose} position="bottom" zIndex={5000}>
      <div className="w-full flex justify-between py-sm px-lg items-center bg-brand-primary">
        <div className="h-[58px] w-[58px] overflow-hidden rounded-lg p-xs bg-white">
          <img src={franchise.logo_url} alt={mobile_app.name} className="h-full w-full object-contain" />
        </div>
        <div onClick={onClose}>
          <CloseCircleIcon />
        </div>
      </div>
      <div className="py-md px-lg">
        <h4
          style={{
            lineHeight: 1.2,
          }}
        >
          {t('title')}
        </h4>
        <p className="text-brand-text-secondary mt-sm">{t('description')}</p>
        <CustomButton
          title={t('buttons.download', { name: mobile_app.name })}
          titleClass="!normal-case"
          onClick={() => {
            openStore({ ascAppId: mobile_app.asc_app_id, bundleId: mobile_app.app_bundle_identifier });
          }}
          className="mt-md"
        />
      </div>
    </CustomModal>
  ) : null;
};

export default DownloadMobileAppModal;
